<template>
  <div v-if="items && items.length" class="mvt-listproperty list-card">
    <mvtShifter ref="shifter" :center="true">
      <mvtCardProperty v-for="item in mappedItems" :key="item.listingId" :data="item" :theme="theme" cardParent="carousel" />
    </mvtShifter>
  </div>
  <div v-else-if="showNoResults" class="mvt-listing-noresult">
    <i class="icon-search f1"></i> {{ molang('dpp.mvtNearby.noResults') }}
  </div>
</template>

<script src="./mvt-listing-carousel.js"></script>

<style lang="scss">
@use "./mvt-listing-carousel.scss" as *;
</style>
